import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { sendReceiptEmail } from '../utils/sendReceiptEmail'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'
import { useDonationsStore } from '@/features/donations/store/donationsStore'

export const useSendDonationReceiptMutation = () => {
  const update = useDonationsStore((state) => state.update)
  const donations = useDonationsStore((state) => state.donations)

  return useMutation({
    mutationFn: ({
      donationId,
    }: {
      donationId: string
      receipt: Blob
      receiptCode: string
    }) => sendReceiptEmail(donationId),
    onSuccess: ({
      message,
      donationId,
      sentToMember,
      sentToMemberAt,
      sentToMemberBy,
    }) => {
      const donation = donations.find((d) => d._id === donationId)
      if (donation) {
        update({ ...donation, sentToMember, sentToMemberAt, sentToMemberBy })
      }

      toast.success(message || 'User edited successfully.')
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while sending receipt email.',
      )
    },
  })
}
